import React, { useCallback, useEffect, useState } from 'react';
import Tabs from './Tabs';

const updateVisibility = (letterbox, component, visibility) => {
  if (letterbox.isNewApi) {
    window.SRGLetterboxConfiguration.updateConfiguration(letterbox.player, {
      components: {
        [component]: visibility,
      }
    });
  } else {
    letterbox.setComponentVisibility(component, visibility);
  }
}

const SRGLetterboxComponents = ({ letterboxInstance }) => {
  const [letterboxComponents, setLetterboxComponents] = useState({});
  const [inactiveComponents, setInactiveComponents] = useState([]);

  const componentVisibilityHandler = useCallback(
    component => {
      if (!letterboxInstance) {
        return null;
      }

      const components = [...inactiveComponents];

      const index = components.indexOf(component);

      if (index < 0) {
        components.push(component);
        console.log('Hides ' + component);
        updateVisibility(letterboxInstance, component, false);
      } else {
        components.splice(index, 1);
        console.log('Shows ' + component);
        updateVisibility(letterboxInstance, component, true);
      }

      setInactiveComponents(components);
    },
    [inactiveComponents, letterboxInstance]
  );

  useEffect(() => {
    if (window.SRGLetterbox && window.SRGLetterbox.srgLetterboxComponents) {
      setInactiveComponents([]);
      setLetterboxComponents({
        ALL: Object.entries(window.SRGLetterbox.srgLetterboxComponents)
      });
    } else {
      setInactiveComponents([]);
      setLetterboxComponents({});
    }
  }, [letterboxInstance]);

  if (!letterboxInstance) {
    return null;
  }

  return (
    <>
      <h1 className="content__title">Components</h1>
      <Tabs>
        {Object.keys(letterboxComponents).map(compCat => {
          const componentCategories = letterboxComponents[compCat];
          return (
            <div key={compCat} label={compCat}>
              <div className="tabs__panel">
                {componentCategories.map(([component, value]) => {
                  const activeClass = inactiveComponents.includes(letterboxInstance.isNewApi ? component : value) ? 'tabs__panel__item--active' : '';
                  return (
                    <div className={`tabs__panel__item ${activeClass}`} key={value} onClick={() => componentVisibilityHandler(letterboxInstance.isNewApi ? component : value)}>
                      {component}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </Tabs>
    </>
  );
};

export default SRGLetterboxComponents;
